
// src/components/ExtraDescriptDialog.jsx
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';

/**
 * Props:
 * - open: boolean
 * - onClose: function
 * - initialValue?: string  // optional initial text for extraDescript
 * - title?: string         // optional dialog title (default: "Extra Description")
 * - helperText?: string    // optional helper text under the field
 * - onConfirm: function(extraDescript: string)
 */
const ExtraDescriptDialog = ({
  open,
  onClose,
  product,
  initialValue = '',
  title = 'Extra Detail',
  helperText = 'Enter any additional description or notes.',
  onConfirm
}) => {
  const [extraDescript, setExtraDescript] = React.useState(initialValue);

  // Reset text whenever we open or initialValue changes
  React.useEffect(() => {
    if (open) setExtraDescript(initialValue || '');
  }, [open, initialValue]);


  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontSize: '2rem', fontWeight: 'bold' }}>{title}</DialogTitle>

      <DialogContent dividers>
        <Typography variant="subtitle1" sx={{ fontSize: '1.25rem', mb: 1, fontWeight: 'bold' }}>
            {product?.extradetail ?? 'No extra details available.'}
        </Typography>

      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExtraDescriptDialog;
